export const environment = {
    production: true,
    baseUrl: 'https://api.sqa1.mstrance.digital-nirvana.com/',
    wsEndpoint: 'wss://gymx4d65nd.execute-api.us-east-1.amazonaws.com/sqa1',
    environmentType: 'sqa1',
  };
